import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeLoadingState,
  dispatch,
  setGymLogin,
  setGymLogout,
  setErrorMessage,
  setGym,
} from "../redux";

export const gymLoginService = async (username, password) => {
  try {
    dispatch(changeLoadingState(true));
    const resp = await httpClient().patch(ApiEndpoints.gymLogin, {
      username,
      password,
    });

    if (!resp.data.success && resp.status >= 201) {
      throw new Error(resp.data.message);
    }

    dispatch(setGymLogin(resp.data.result.token));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(changeLoadingState(false));
    dispatch(setErrorMessage(error.message));
  }
};

export const forgetGymPasswordService = async (username) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.forgetGymPassword, {
      username,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const resetGymPasswordService = async (
  token,
  password,
  confirmPassword
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.resetGymPassword, {
      token,
      password,
      confirmPassword,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};



export const getGymProfile = async () => {
 try {
   // Set Loading
   dispatch(changeLoadingState(true));

   // API Fetching
   const resp = await httpClient().get(ApiEndpoints.gymProfile);

   // Handle Error
   if (resp.status > 201 || !resp.data.success) {
     throw new Error(resp.data.message);
   }

   // Update to Store
   dispatch(setGym(resp.data.result));
   // dispatch(setSuccessMessage(resp.data.message));
   return true;
 } catch (error) {
   // Set Error message to store
   dispatch(setErrorMessage(error.message ?? "Error happended"));
   dispatch(changeLoadingState(false));
 }
};



/**
 * To delete the Gym permanently
 */
// In your actions file
export const logoutGym = () => async (dispatch) => {
  try {
    dispatch(changeLoadingState(true));
    dispatch(setGymLogout());
    return true;
  } catch (error) {
    dispatch(setErrorMessage(error.message || "Error occurred"));
    dispatch(changeLoadingState(false));
  }
};




